import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/tailwindcss/tailwind.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/assets/fonts/fonts.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/assets/icons/iconsax-css/style.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/react-datepicker/dist/react-datepicker.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/global.css");
